import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./reducers/auth";
import { uiReducer } from "./reducers/sideMenu"; 

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer, 
  },
});

export default store;
